
let PRODUCTS = [];
const BRAND_PRETTY = {"MHW-3BOMBER": "MHW-3Bomber", "AEROPRESS": "AeroPress", "CAFETTO": "Cafetto", "HARIO": "Hario", "TODDY": "Toddy", "PUQPRESS": "Puqpress", "BARATZA": "Baratza", "RHINO": "Rhino", "KALERM": "Kalerm", "WACACO": "Wacaco", "EUREKA": "Eureka", "FELLOW": "Fellow", "KINTO": "Kinto", "NUCLEUS": "Nucleus", "IBERITAL": "Iberital", "ECM": "ECM", "PALLO": "Pallo", "URNEX": "Urnex", "CAFELAT": "Cafelat", "GAGGIA": "Gaggia", "MARCO": "Marco", "PRECISE": "Precise", "CAYE": "Caye", "NUTTI": "Nutti", "PEAK-WATER": "Peak Water", "VST": "VST", "WEBER": "Weber", "BPLUS": "BPlus", "E&B LAB": "E&B Lab", "ECOSOFT": "Ecosoft", "ESPAZZOLA": "Espazzola", "GIESEN": "Giesen", "LA PAVONI": "La Pavoni", "MORNING": "Morning", "SUBMINIMAL": "Subminimal", "ALMOROOJ": "Almorooj", "ANKOMN": "Ankomn", "BREWISTA": "Brewista", "BWT": "BWT", "CINOART": "Cinoart", "KALITA": "Kalita", "NOWXPRESSO": "NowXpresso", "TIMEMORE": "Timemore", "WPM": "WPM", "A-IDIO": "A-Idio"};

// ---------- State ----------
const state = {
  brand: 'ALL',
  sort: { col: 'name', dir: 'asc' },
  search: '',
  expanded: new Set(),
  filterRefOnly: false,
  filterTopMargin: false,
  priceMin: null,
  priceMax: null,
};
const cart = new Map(); // key -> {product, qty}
let cartTier = 'auto';
const compareSet = new Set();

// ---------- Helpers ----------
const fmt = {
  money: n => n == null ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 3 }),
  money0: n => n == null ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
  pct: n => n == null ? '—' : (n * 100).toFixed(1) + '%',
  int: n => Number(n).toLocaleString('en-US'),
};

function prettyBrand(b) { return BRAND_PRETTY[b] || b; }

function splitName(name) {
  // Split product name into english + arabic parts when present (delimited by ' - ')
  const idx = name.lastIndexOf(' - ');
  if (idx === -1) return { en: name, ar: '' };
  const left = name.substring(0, idx);
  const right = name.substring(idx + 3);
  // Detect if right side contains arabic
  if (/[\u0600-\u06FF]/.test(right)) return { en: left, ar: right };
  return { en: name, ar: '' };
}

function avgMargin(p) {
  // Margin at the P5-11 tier (most common business case)
  if (!p.p5) return 0;
  return (p.p5 - p.cost) / p.p5;
}

function profit(price, cost) { return price - cost; }

function brandStats(brand) {
  const list = brand === 'ALL' ? PRODUCTS : PRODUCTS.filter(p => p.brand === brand);
  if (!list.length) return { count: 0, avgPrice: 0, avgP1: 0, avgP5: 0, avgP12: 0 };
  const n = list.length;
  return {
    count: n,
    avgPrice: list.reduce((a, p) => a + p.sales_price, 0) / n,
    avgP1:    list.reduce((a, p) => a + p.p1, 0) / n,
    avgP5:    list.reduce((a, p) => a + p.p5, 0) / n,
    avgP12:   list.reduce((a, p) => a + p.p12, 0) / n,
  };
}

// ---------- Render: KPIs ----------
function renderKPIs() {
  const stats = brandStats('ALL');
  const totalBrands = new Set(PRODUCTS.map(p => p.brand)).size;
  const brandCounts = {};
  PRODUCTS.forEach(p => brandCounts[p.brand] = (brandCounts[p.brand] || 0) + 1);
  const topBrand = Object.entries(brandCounts).sort((a,b) => b[1] - a[1])[0];

  const kpis = [
    { label: 'Total Products', value: fmt.int(stats.count), sub: 'Across all brands' },
    { label: 'Brands', value: fmt.int(totalBrands), sub: 'Unique partners' },
    { label: 'Avg Sales Price', value: fmt.money0(stats.avgPrice), sub: 'KWD' },
    { label: 'Avg Price (5–11)', value: fmt.money0(stats.avgP5), sub: 'KWD' },
    { label: 'Top Brand', value: prettyBrand(topBrand[0]), sub: `<strong>${topBrand[1]}</strong> products`, small: true },
  ];

  document.getElementById('kpiRow').innerHTML = kpis.map(k => `
    <div class="kpi">
      <div class="kpi__label">${k.label}</div>
      <div class="kpi__value ${k.small ? 'kpi__value--small' : ''}">${k.value}</div>
      <div class="kpi__sub">${k.sub}</div>
    </div>
  `).join('');
}

// ---------- Render: Brand list (sidebar) ----------
function renderBrandList() {
  const counts = {};
  PRODUCTS.forEach(p => counts[p.brand] = (counts[p.brand] || 0) + 1);
  const brands = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  const total = PRODUCTS.length;

  const items = [
    `<li class="brand-tab ${state.brand === 'ALL' ? 'is-active' : ''}" data-brand="ALL">
      <span class="brand-tab__name">All Products</span>
      <span class="brand-tab__count">${total}</span>
    </li>`
  ].concat(brands.map(([b, c]) => `
    <li class="brand-tab ${state.brand === b ? 'is-active' : ''}" data-brand="${b}">
      <span class="brand-tab__name">${prettyBrand(b)}</span>
      <span class="brand-tab__count">${c}</span>
    </li>
  `));

  document.getElementById('brandList').innerHTML = items.join('');
  document.querySelectorAll('.brand-tab').forEach(el => {
    el.addEventListener('click', () => {
      state.brand = el.dataset.brand;
      state.expanded.clear();
      renderBrandList();
      renderContent();
    });
  });
}

// ---------- Render: Content area ----------
function renderContent() {
  const c = document.getElementById('content');
  let list = state.brand === 'ALL' ? PRODUCTS.slice() : PRODUCTS.filter(p => p.brand === state.brand);

  // Search filter
  if (state.search) {
    const q = state.search.toLowerCase();
    list = list.filter(p =>
      p.name.toLowerCase().includes(q) ||
      p.ref.toLowerCase().includes(q) ||
      prettyBrand(p.brand).toLowerCase().includes(q)
    );
  }

  // Advanced filters
  if (state.filterRefOnly) list = list.filter(p => p.ref && p.ref.length > 0);
  if (state.filterTopMargin) list = list.filter(p => avgMargin(p) > 0.5);
  if (state.priceMin != null) list = list.filter(p => p.p5 >= state.priceMin);
  if (state.priceMax != null) list = list.filter(p => p.p5 <= state.priceMax);

  // Sort
  const dir = state.sort.dir === 'asc' ? 1 : -1;
  list.sort((a, b) => {
    let av, bv;
    switch (state.sort.col) {
      case 'name': av = a.name; bv = b.name; break;
      case 'sales_price': av = a.sales_price; bv = b.sales_price; break;
      case 'p1': av = a.p1; bv = b.p1; break;
      case 'p5': av = a.p5; bv = b.p5; break;
      case 'p12': av = a.p12; bv = b.p12; break;
      default: av = a.name; bv = b.name;
    }
    if (typeof av === 'string') return av.localeCompare(bv) * dir;
    return (av - bv) * dir;
  });

  const stats = brandStats(state.brand);
  const titleText = state.brand === 'ALL' ? 'All Products' : prettyBrand(state.brand);

  c.innerHTML = `
    <div class="brand-header">
      <div>
        <h1 class="brand-header__title">${titleText}<sup>${stats.count.toString().padStart(2,'0')}</sup></h1>
      </div>
      <div class="brand-header__meta">
        <div class="brand-stat">
          <div class="brand-stat__label">Avg · Tier 1</div>
          <div class="brand-stat__value">${fmt.money0(stats.avgP1)}</div>
        </div>
        <div class="brand-stat">
          <div class="brand-stat__label">Avg · Tier 2</div>
          <div class="brand-stat__value">${fmt.money0(stats.avgP5)}</div>
        </div>
        <div class="brand-stat">
          <div class="brand-stat__label">Avg · Tier 3</div>
          <div class="brand-stat__value">${fmt.money0(stats.avgP12)}</div>
        </div>
      </div>
    </div>

    <div class="actions-bar">
      <div class="actions-bar__group">
        <button class="filter-chip ${state.filterRefOnly ? 'is-active' : ''}" data-action="toggle-ref">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"/></svg>
          Has reference only
        </button>
        <button class="filter-chip ${state.filterTopMargin ? 'is-active' : ''}" data-action="toggle-margin">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m23 6-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></svg>
          Top margin (>50%)
        </button>
        <div class="price-range">
          <span style="color:var(--muted);font-weight:500;">KWD</span>
          <input type="number" id="priceMin" placeholder="Min" min="0" value="${state.priceMin || ''}">
          <span class="price-range__sep">–</span>
          <input type="number" id="priceMax" placeholder="Max" min="0" value="${state.priceMax || ''}">
        </div>
        ${(state.filterRefOnly || state.filterTopMargin || state.priceMin || state.priceMax) ? `
          <button class="filter-chip" data-action="clear-filters" style="color:var(--bad);border-color:var(--bad);">
            Clear filters
          </button>
        ` : ''}
      </div>
      <div class="actions-bar__group">
        <button class="icon-btn" data-action="export-csv" title="Export current view to CSV">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          CSV
        </button>
        <button class="icon-btn" data-action="export-pdf" title="Export current view to PDF">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          PDF
        </button>
      </div>
    </div>

    <div class="toolbar">
      <div class="toolbar__left">
        Showing <strong>${list.length}</strong> ${list.length === 1 ? 'product' : 'products'}
        ${state.search ? `matching "<strong>${state.search}</strong>"` : ''}
      </div>
      <div class="toolbar__right">
        <span style="font-size:11px; color:var(--muted); letter-spacing:0.1em; text-transform:uppercase; margin-right:4px;">Sort</span>
        ${[
          {key:'name', label:'Name'},
          {key:'sales_price', label:'Sales'},
          {key:'p1', label:'Tier 1'},
          {key:'p5', label:'Tier 2'},
          {key:'p12', label:'Tier 3'}
        ].map(s => `
          <button class="sort-btn ${state.sort.col === s.key ? 'is-active' : ''}" data-sort="${s.key}">
            ${s.label}
            ${state.sort.col === s.key ? (state.sort.dir === 'asc' ? '↑' : '↓') : ''}
          </button>
        `).join('')}
      </div>
    </div>

    ${list.length === 0 ? `
      <div class="empty">
        <div class="empty__icon">∅</div>
        <div class="empty__title">No products found</div>
        <div>Try a different brand or search term.</div>
      </div>
    ` : `
    <div class="product-table-wrap">
      <table class="product-table">
        <thead>
          <tr>
            <th style="width: 38px;"></th>
            <th style="width: 100px;">Reference</th>
            <th>Product</th>
            ${state.brand === 'ALL' ? '<th style="width: 100px;">Brand</th>' : ''}
            <th class="num" style="width: 80px;">Sales</th>
            <th class="num" style="width: 70px;">Tier 1</th>
            <th class="num" style="width: 70px;">Tier 2 <span style="color:var(--orange);">(5–11)</span></th>
            <th class="num" style="width: 70px;">Tier 3 <span style="color:var(--muted);">(12+)</span></th>
            <th style="width: 70px;"></th>
          </tr>
        </thead>
        <tbody id="rows">
          ${list.map((p, i) => renderRow(p, i)).join('')}
        </tbody>
      </table>
    </div>
    `}
  `;

  // Wire up sort buttons
  document.querySelectorAll('.sort-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const col = btn.dataset.sort;
      if (state.sort.col === col) {
        state.sort.dir = state.sort.dir === 'asc' ? 'desc' : 'asc';
      } else {
        state.sort.col = col;
        state.sort.dir = 'asc';
      }
      renderContent();
    });
  });

  // Wire up row clicks for expansion
  document.querySelectorAll('.product-table tbody tr.product-row').forEach(row => {
    row.addEventListener('click', () => {
      const ref = row.dataset.key;
      if (state.expanded.has(ref)) state.expanded.delete(ref);
      else state.expanded.add(ref);
      renderContent();
    });
  });

  // Add-to-cart buttons
  document.querySelectorAll('.row-add').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const key = btn.dataset.cartKey;
      const product = list.find(p => (p.ref || `${p.brand}-${list.indexOf(p)}`) === key)
                   || PRODUCTS.find(p => p.ref === key);
      if (!product) return;
      if (cart.has(key)) {
        cart.delete(key);
      } else {
        cart.set(key, { product, qty: 1 });
      }
      renderContent();
      renderCart();
      updateCartBadge();
    });
  });

  // Compare checkboxes
  document.querySelectorAll('.row-check').forEach(box => {
    box.addEventListener('click', (e) => {
      e.stopPropagation();
      const key = box.dataset.compareKey;
      if (compareSet.has(key)) {
        compareSet.delete(key);
      } else {
        if (compareSet.size >= 4) {
          alert('You can compare up to 4 products at a time.');
          return;
        }
        compareSet.add(key);
      }
      renderContent();
      updateCompareBar();
    });
  });

  // Filter chips
  document.querySelectorAll('[data-action]').forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.action;
      if (action === 'toggle-ref') state.filterRefOnly = !state.filterRefOnly;
      else if (action === 'toggle-margin') state.filterTopMargin = !state.filterTopMargin;
      else if (action === 'clear-filters') {
        state.filterRefOnly = false;
        state.filterTopMargin = false;
        state.priceMin = null;
        state.priceMax = null;
      } else if (action === 'export-csv') exportCSV(list);
      else if (action === 'export-pdf') exportPDF(list);
      if (action.startsWith('toggle-') || action === 'clear-filters') renderContent();
    });
  });

  // Price range inputs (debounced)
  const minInput = document.getElementById('priceMin');
  const maxInput = document.getElementById('priceMax');
  if (minInput) {
    minInput.addEventListener('input', debounce(() => {
      state.priceMin = minInput.value ? Number(minInput.value) : null;
      renderContent();
      // Re-focus to keep cursor in the field after re-render
      const newMin = document.getElementById('priceMin');
      if (newMin) { newMin.focus(); newMin.setSelectionRange(newMin.value.length, newMin.value.length); }
    }, 350));
  }
  if (maxInput) {
    maxInput.addEventListener('input', debounce(() => {
      state.priceMax = maxInput.value ? Number(maxInput.value) : null;
      renderContent();
      const newMax = document.getElementById('priceMax');
      if (newMax) { newMax.focus(); newMax.setSelectionRange(newMax.value.length, newMax.value.length); }
    }, 350));
  }
}

// ---------- Debounce helper ----------
function debounce(fn, ms) {
  let t;
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
}

function renderRow(p, i) {
  const split = splitName(p.name);
  const key = p.ref || `${p.brand}-${i}`;
  const expanded = state.expanded.has(key);
  const inCart = cart.has(key);
  const inCompare = compareSet.has(key);

  let html = `
    <tr class="product-row ${expanded ? 'is-expanded' : ''}" data-key="${key}" style="animation-delay: ${Math.min(i, 20) * 0.015}s">
      <td onclick="event.stopPropagation();">
        <div class="row-check ${inCompare ? 'checked' : ''}" data-compare-key="${key}" title="Add to comparison">
          ${inCompare ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>' : ''}
        </div>
      </td>
      <td><span class="ref">${p.ref || '—'}</span></td>
      <td>
        <div class="product-name">${split.en}</div>
        ${split.ar ? `<span class="product-name__ar">${split.ar}</span>` : ''}
      </td>
      ${state.brand === 'ALL' ? `<td><strong style="font-size:12px;">${prettyBrand(p.brand)}</strong></td>` : ''}
      <td class="num"><span class="price-pill price-sales">${fmt.money(p.sales_price)}</span></td>
      <td class="num">${fmt.money(p.p1)}</td>
      <td class="num"><strong>${fmt.money(p.p5)}</strong></td>
      <td class="num" style="color:var(--muted);">${fmt.money(p.p12)}</td>
      <td onclick="event.stopPropagation();" style="text-align:right;">
        <div class="row-add ${inCart ? 'in-cart' : ''}" data-cart-key="${key}" title="${inCart ? 'In quote' : 'Add to quote'}">
          ${inCart ?
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>' :
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>'
          }
        </div>
      </td>
    </tr>
  `;

  if (expanded) {
    const cols = state.brand === 'ALL' ? 9 : 8;
    html += `
      <tr class="detail-row">
        <td colspan="${cols}">
          <div class="detail-content">
            <div>
              <div class="detail-headline">${split.en}</div>
              <div class="detail-meta">${prettyBrand(p.brand)} · ${p.ref || 'No reference'}</div>
              ${split.ar ? `<div style="direction:rtl; font-size:14px; color:#ccc; margin-top:6px;">${split.ar}</div>` : ''}
            </div>
            <div class="detail-block">
              <div class="detail-block__label">Sales Price</div>
              <div class="detail-big">${fmt.money(p.sales_price)} <span class="detail-unit">KWD</span></div>
            </div>
            <div class="detail-block">
              <div class="detail-block__label">Tier Pricing (KWD)</div>
              <div class="detail-tier">
                <span class="detail-tier__name">Tier 1 · 1 unit</span>
                <span class="detail-tier__val profit">${fmt.money(p.p1)}</span>
              </div>
              <div class="detail-tier">
                <span class="detail-tier__name">Tier 2 · 5–11 units</span>
                <span class="detail-tier__val profit">${fmt.money(p.p5)}</span>
              </div>
              <div class="detail-tier">
                <span class="detail-tier__name">Tier 3 · 12+ units</span>
                <span class="detail-tier__val profit">${fmt.money(p.p12)}</span>
              </div>
            </div>
          </div>
        </td>
      </tr>
    `;
  }
  return html;
}


// ---------- Cart (Quick Quote) ----------
function getProductByKey(key) {
  for (const p of PRODUCTS) {
    const k = p.ref || `${p.brand}-${PRODUCTS.indexOf(p)}`;
    if (k === key) return p;
  }
  return null;
}

function tierLabel(t) {
  return { sales_price: 'Sales Price', auto: 'Tier Pricing (Auto)', p1: 'Tier 1 (1 unit)', p5: 'Tier 2 (5–11)', p12: 'Tier 3 (12+)' }[t] || t;
}

// Pick the right unit price based on cart mode + quantity
function unitPriceFor(product, qty) {
  if (cartTier === 'sales_price') return Number(product.sales_price) || 0;
  // Auto-tier by quantity
  if (qty >= 12) return Number(product.p12) || 0;
  if (qty >= 5)  return Number(product.p5)  || 0;
  return Number(product.p1) || 0;
}

// Short label for which tier was applied to a given qty
function tierAppliedFor(qty) {
  if (cartTier === 'sales_price') return 'Sales';
  if (qty >= 12) return 'Tier 3';
  if (qty >= 5)  return 'Tier 2';
  return 'Tier 1';
}

function renderCart() {
  const body = document.getElementById('cartBody');
  const foot = document.getElementById('cartFoot');
  const sub = document.getElementById('cartHeadSub');
  if (!body) return;

  if (cart.size === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <div class="cart-empty__icon">📋</div>
        <div class="cart-empty__title">Empty quote</div>
        <div>Click + on any product to add it.</div>
      </div>
    `;
    foot.style.display = 'none';
    sub.textContent = '0 items';
    return;
  }

  let totalUnits = 0;
  let totalAmount = 0;
  let rowsHtml = '';
  for (const [key, item] of cart) {
    const p = item.product;
    const unitPrice = unitPriceFor(p, item.qty);
    const lineTotal = unitPrice * item.qty;
    const tierTag = tierAppliedFor(item.qty);
    totalUnits += item.qty;
    totalAmount += lineTotal;
    const split = splitName(p.name);
    rowsHtml += `
      <div class="cart-item">
        <div>
          <div class="cart-item__name">${split.en}</div>
          <div class="cart-item__meta">${prettyBrand(p.brand)} · ${p.ref || '—'}</div>
        </div>
        <div class="cart-item__price">
          <div class="cart-item__unit">
            <span class="cart-tier-tag">${tierTag}</span>
            ${fmt.money(unitPrice)} × ${item.qty}
          </div>
          <div class="cart-item__total">${fmt.money(lineTotal)}</div>
        </div>
        <div class="cart-item__qty">
          <button class="qty-btn" data-cart-act="dec" data-key="${key}">−</button>
          <input type="number" class="qty-input" value="${item.qty}" min="1" data-cart-act="qty" data-key="${key}">
          <button class="qty-btn" data-cart-act="inc" data-key="${key}">+</button>
          <button class="cart-item__remove" data-cart-act="rm" data-key="${key}">Remove</button>
        </div>
      </div>
    `;
  }

  body.innerHTML = rowsHtml;
  foot.style.display = 'block';
  sub.textContent = `${cart.size} item${cart.size === 1 ? '' : 's'}`;
  document.getElementById('cartItemCount').textContent = cart.size;
  document.getElementById('cartUnitCount').textContent = totalUnits;
  document.getElementById('cartTotal').textContent = fmt.money(totalAmount) + ' KWD';

  // Wire up cart item actions
  body.querySelectorAll('[data-cart-act]').forEach(el => {
    el.addEventListener(el.tagName === 'INPUT' ? 'change' : 'click', () => {
      const key = el.dataset.key;
      const act = el.dataset.cartAct;
      const item = cart.get(key);
      if (!item) return;
      if (act === 'inc') item.qty++;
      else if (act === 'dec') { item.qty = Math.max(1, item.qty - 1); }
      else if (act === 'qty') { item.qty = Math.max(1, parseInt(el.value) || 1); }
      else if (act === 'rm') { cart.delete(key); renderContent(); updateCartBadge(); }
      renderCart();
    });
  });
}

function updateCartBadge() {
  const badge = document.getElementById('cartBadge');
  if (!badge) return;
  if (cart.size === 0) {
    badge.style.display = 'none';
  } else {
    badge.style.display = 'flex';
    badge.textContent = cart.size;
  }
}

function openCart() {
  document.getElementById('cartPanel').classList.add('is-open');
  document.getElementById('cartOverlay').classList.add('is-open');
  renderCart();
}
function closeCart() {
  document.getElementById('cartPanel').classList.remove('is-open');
  document.getElementById('cartOverlay').classList.remove('is-open');
}

function buildQuoteText() {
  const date = new Date().toLocaleDateString('en-GB');
  const tier = tierLabel(cartTier);
  let lines = [
    `48 East · Quote`,
    `Date: ${date} · Pricing: ${tier}`,
    ``.padEnd(60, '─'),
  ];
  let total = 0;
  for (const [key, item] of cart) {
    const p = item.product;
    const unit = unitPriceFor(p, item.qty);
    const sub = unit * item.qty;
    const tierTag = tierAppliedFor(item.qty);
    total += sub;
    lines.push(`${p.ref || '—'}  ${splitName(p.name).en}`);
    lines.push(`  ${item.qty} × ${fmt.money(unit)} (${tierTag}) = ${fmt.money(sub)} KWD`);
  }
  lines.push(``.padEnd(60, '─'));
  lines.push(`TOTAL: ${fmt.money(total)} KWD`);
  return lines.join('\n');
}

async function copyQuote() {
  const text = buildQuoteText();
  try {
    await navigator.clipboard.writeText(text);
    const btn = document.getElementById('cartCopy');
    const old = btn.innerHTML;
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg> Copied!';
    setTimeout(() => { btn.innerHTML = old; }, 1500);
  } catch (e) {
    alert('Copy failed. Quote:\n\n' + text);
  }
}

function exportQuotePDF() {
  const date = new Date().toLocaleDateString('en-GB');
  const tier = tierLabel(cartTier);
  let total = 0;
  let rows = '';
  for (const [key, item] of cart) {
    const p = item.product;
    const unit = unitPriceFor(p, item.qty);
    const sub = unit * item.qty;
    const tierTag = tierAppliedFor(item.qty);
    total += sub;
    rows += `<tr>
      <td>${p.ref || '—'}</td>
      <td>${splitName(p.name).en}</td>
      <td style="text-align:center;">${item.qty}</td>
      <td style="text-align:center;font-size:10px;color:#888;">${tierTag}</td>
      <td style="text-align:right;font-family:monospace;">${fmt.money(unit)}</td>
      <td style="text-align:right;font-family:monospace;font-weight:bold;">${fmt.money(sub)}</td>
    </tr>`;
  }
  const doc = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>48 East Quote</title>
    <style>
      body { font-family: -apple-system, system-ui, sans-serif; padding: 40px; color: #111; }
      .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #FF6C0E; padding-bottom: 16px; margin-bottom: 24px; }
      h1 { font-size: 28px; margin: 0; }
      .meta { font-size: 12px; color: #666; }
      table { width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 13px; }
      th { background: #000; color: #fff; padding: 10px; text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; }
      td { padding: 12px 10px; border-bottom: 1px solid #eee; }
      tr:nth-child(even) td { background: #fafafa; }
      .total { background: #000; color: #fff; padding: 18px 24px; display: flex; justify-content: space-between; align-items: center; margin-top: 20px; border-radius: 6px; }
      .total-label { font-size: 14px; text-transform: uppercase; letter-spacing: 0.1em; }
      .total-amount { font-size: 28px; font-weight: bold; color: #FF6C0E; font-family: monospace; }
    </style></head><body>
    <div class="header">
      <div>
        <h1>48 East Quote</h1>
        <div class="meta">Date: ${date} · Pricing tier: ${tier}</div>
      </div>
      <div style="font-weight:bold;font-size:32px;">48<span style="border:2px solid #000;border-radius:50%;padding:0 6px;font-size:18px;margin-left:4px;">E</span></div>
    </div>
    <table>
      <thead><tr><th>Ref</th><th>Product</th><th style="text-align:center;">Qty</th><th style="text-align:center;">Tier</th><th style="text-align:right;">Unit</th><th style="text-align:right;">Total</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="total">
      <span class="total-label">Grand Total</span>
      <span class="total-amount">${fmt.money(total)} KWD</span>
    </div>
    <p style="text-align:center;margin-top:40px;font-size:11px;color:#999;">Generated from 48 East Product Dashboard</p>
    <script>window.onload = () => setTimeout(() => window.print(), 300);<\/script>
  </body></html>`;
  const w = window.open('', '_blank');
  w.document.write(doc);
  w.document.close();
}

function clearCart() {
  if (cart.size === 0) return;
  if (confirm('Clear all ' + cart.size + ' items from quote?')) {
    cart.clear();
    renderContent();
    renderCart();
    updateCartBadge();
  }
}

// ---------- Compare ----------
function updateCompareBar() {
  const bar = document.getElementById('compareBar');
  const count = document.getElementById('compareCount');
  count.textContent = compareSet.size;
  if (compareSet.size > 0) bar.classList.add('is-open');
  else bar.classList.remove('is-open');
  document.getElementById('compareOpen').disabled = compareSet.size < 2;
}

function openCompareModal() {
  if (compareSet.size < 2) return;
  const products = [];
  for (const key of compareSet) {
    const p = getProductByKey(key);
    if (p) products.push(p);
  }
  if (products.length < 2) return;

  // Find best (lowest cost, lowest sales price, highest margin)
  const minBy = (arr, fn) => arr.reduce((b, c) => fn(c) < fn(b) ? c : b);
  const maxBy = (arr, fn) => arr.reduce((b, c) => fn(c) > fn(b) ? c : b);
  const bestSales = minBy(products, p => p.sales_price || Infinity);
  const bestP1 = minBy(products, p => p.p1 || Infinity);
  const bestP5 = minBy(products, p => p.p5 || Infinity);
  const bestP12 = minBy(products, p => p.p12 || Infinity);
  const bestMargin = maxBy(products, p => avgMargin(p));

  const cellBest = (val, fmt_) => `<td class="num best">${fmt_(val)}</td>`;
  const cell = (val, fmt_) => `<td class="num">${fmt_(val)}</td>`;

  const head = '<th>Field</th>' + products.map(p => `<td class="col-product">${splitName(p.name).en}</td>`).join('');
  const rowBrand = '<th>Brand</th>' + products.map(p => `<td>${prettyBrand(p.brand)}</td>`).join('');
  const rowRef = '<th>Reference</th>' + products.map(p => `<td><span class="ref">${p.ref || '—'}</span></td>`).join('');
  const rowSales = '<th>Sales Price</th>' + products.map(p => p === bestSales ? cellBest(p.sales_price, fmt.money) : cell(p.sales_price, fmt.money)).join('');
  const rowP1 = '<th>Tier 1</th>' + products.map(p => p === bestP1 ? cellBest(p.p1, fmt.money) : cell(p.p1, fmt.money)).join('');
  const rowP5 = '<th>Tier 2 (5–11)</th>' + products.map(p => p === bestP5 ? cellBest(p.p5, fmt.money) : cell(p.p5, fmt.money)).join('');
  const rowP12 = '<th>Tier 3 (12+)</th>' + products.map(p => p === bestP12 ? cellBest(p.p12, fmt.money) : cell(p.p12, fmt.money)).join('');
  const rowMargin = '<th>Margin (T2)</th>' + products.map(p => p === bestMargin ? `<td class="num best">${fmt.pct(avgMargin(p))}</td>` : `<td class="num">${fmt.pct(avgMargin(p))}</td>`).join('');

  document.getElementById('compareModalBody').innerHTML = `
    <p style="font-size:12px;color:var(--muted);margin-bottom:14px;">
      <span class="best" style="padding:1px 6px;border-radius:3px;">Highlighted</span> = best value in row
    </p>
    <table class="compare-table">
      <thead><tr>${head}</tr></thead>
      <tbody>
        <tr>${rowBrand}</tr>
        <tr>${rowRef}</tr>
        <tr>${rowSales}</tr>
        <tr>${rowP1}</tr>
        <tr>${rowP5}</tr>
        <tr>${rowP12}</tr>
        <tr>${rowMargin}</tr>
      </tbody>
    </table>
  `;
  document.getElementById('compareModal').classList.add('is-open');
}

function closeCompareModal() {
  document.getElementById('compareModal').classList.remove('is-open');
}

function clearCompare() {
  compareSet.clear();
  renderContent();
  updateCompareBar();
}

// ---------- Export ----------
function exportCSV(list) {
  const headers = ['Reference','Brand','Product','Sales Price','Tier 1','Tier 2 (5-11)','Tier 3 (12+)'];
  const rows = list.map(p => [
    p.ref || '',
    prettyBrand(p.brand),
    splitName(p.name).en + (splitName(p.name).ar ? ' - ' + splitName(p.name).ar : ''),
    p.sales_price,
    p.p1,
    p.p5,
    p.p12,
  ]);
  const escape = v => {
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const csv = [headers, ...rows].map(r => r.map(escape).join(',')).join('\n');
  // Add UTF-8 BOM so Arabic renders correctly in Excel
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const brandLabel = state.brand === 'ALL' ? 'all-products' : state.brand.toLowerCase();
  a.href = url;
  a.download = `48east-${brandLabel}-${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function exportPDF(list) {
  const date = new Date().toLocaleDateString('en-GB');
  const brandLabel = state.brand === 'ALL' ? 'All Products' : prettyBrand(state.brand);
  const rows = list.map(p => {
    const split = splitName(p.name);
    return `<tr>
      <td><code>${p.ref || '—'}</code></td>
      <td>${state.brand === 'ALL' ? `<small style="color:#888;">${prettyBrand(p.brand)}</small><br>` : ''}${split.en}${split.ar ? `<br><span style="color:#888;font-size:11px;direction:rtl;">${split.ar}</span>` : ''}</td>
      <td class="num" style="background:#FFF1E5;color:#C24E00;font-weight:bold;">${fmt.money(p.sales_price)}</td>
      <td class="num">${fmt.money(p.p1)}</td>
      <td class="num"><strong>${fmt.money(p.p5)}</strong></td>
      <td class="num" style="color:#888;">${fmt.money(p.p12)}</td>
    </tr>`;
  }).join('');
  const doc = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>48 East — ${brandLabel}</title>
    <style>
      @page { size: A4; margin: 1.5cm; }
      body { font-family: -apple-system, system-ui, sans-serif; color: #111; }
      .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #FF6C0E; padding-bottom: 14px; margin-bottom: 18px; }
      h1 { font-size: 24px; margin: 0; }
      .meta { font-size: 11px; color: #666; margin-top: 4px; }
      .badge { background: #000; color: #fff; padding: 4px 10px; font-size: 11px; border-radius: 3px; text-transform: uppercase; letter-spacing: 0.1em; }
      table { width: 100%; border-collapse: collapse; font-size: 11px; }
      th { background: #000; color: #fff; padding: 8px 6px; text-align: left; font-size: 10px; text-transform: uppercase; letter-spacing: 0.08em; }
      td { padding: 8px 6px; border-bottom: 1px solid #eee; vertical-align: top; }
      .num { text-align: right; font-family: monospace; }
      tr:nth-child(even) td { background: #fafafa; }
      code { background: #f5f5f5; padding: 1px 5px; border-radius: 2px; font-size: 10px; }
      .footer { text-align: center; margin-top: 30px; font-size: 10px; color: #999; }
    </style></head><body>
    <div class="header">
      <div>
        <h1>${brandLabel}</h1>
        <div class="meta">${list.length} products · ${date}</div>
      </div>
      <div style="text-align:right;">
        <div style="font-weight:bold;font-size:28px;">48<span style="border:2px solid #000;border-radius:50%;padding:0 5px;font-size:16px;">E</span></div>
        <div class="badge" style="margin-top:6px;">48 East</div>
      </div>
    </div>
    <table>
      <thead><tr>
        <th style="width:80px;">Ref</th>
        <th>Product</th>
        <th class="num" style="width:60px;">Sales</th>
        <th class="num" style="width:55px;">Tier 1</th>
        <th class="num" style="width:55px;">Tier 2</th>
        <th class="num" style="width:55px;">Tier 3</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <p class="footer">All prices in KWD · Generated from 48 East Product Dashboard</p>
    <script>window.onload = () => setTimeout(() => window.print(), 300);<\/script>
  </body></html>`;
  const w = window.open('', '_blank');
  w.document.write(doc);
  w.document.close();
}

// ---------- Search ----------
let searchTimer;
document.getElementById('search').addEventListener('input', e => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    state.search = e.target.value.trim();
    state.expanded.clear();
    renderContent();
  }, 150);
});

// ---------- Cart, Compare & global handlers ----------
document.getElementById('cartToggle').addEventListener('click', openCart);
document.getElementById('cartClose').addEventListener('click', closeCart);
document.getElementById('cartOverlay').addEventListener('click', closeCart);
document.getElementById('cartCopy').addEventListener('click', copyQuote);
document.getElementById('cartPdf').addEventListener('click', exportQuotePDF);
document.getElementById('cartClear').addEventListener('click', clearCart);

document.querySelectorAll('.cart-tier-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.cart-tier-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    cartTier = btn.dataset.tier;
    renderCart();
  });
});

document.getElementById('compareOpen').addEventListener('click', openCompareModal);
document.getElementById('compareClear').addEventListener('click', clearCompare);
document.getElementById('compareModalClose').addEventListener('click', closeCompareModal);
document.getElementById('compareModal').addEventListener('click', (e) => {
  if (e.target.id === 'compareModal') closeCompareModal();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCompareModal();
    closeCart();
  }
});

// // ---------- Google Sheets connection ----------
const SHEET_ID = "1VzFa8PCpBNa-ldL--Xx1aBKDf_dv-WcKSn3GJ0dR_mw";
const SHEET_NAME = "Sheet1";
const AUTO_REFRESH_MS = 5 * 60 * 1000; // 5 minutes
const SHEET_URL = "https://docs.google.com/spreadsheets/d/" + SHEET_ID + "/gviz/tq?tqx=out:json&sheet=" + encodeURIComponent(SHEET_NAME);

let lastRefresh = null;
let isLoading = false;

function showLoadingState() {
  document.getElementById('content').innerHTML =
    '<div class="state-overlay">' +
      '<div class="state-overlay__icon spin">↻</div>' +
      '<div class="state-overlay__title">Loading products…</div>' +
      '<div class="state-overlay__msg">Fetching latest data from Google Sheets</div>' +
    '</div>';
}

function showErrorState(err) {
  document.getElementById('content').innerHTML =
    '<div class="state-overlay">' +
      '<div class="state-overlay__icon">⚠</div>' +
      '<div class="state-overlay__title">Could not load data</div>' +
      '<div class="state-overlay__msg">' + err + '<br><br>' +
      'Make sure the Google Sheet is shared as <code>Anyone with the link → Viewer</code> ' +
      'and the tab is named <code>' + SHEET_NAME + '</code>.</div>' +
    '</div>';
}

function updateStatusBadge() {
  const el = document.getElementById('refreshStatus');
  if (!el) return;
  if (isLoading) { el.textContent = 'Refreshing…'; el.className = 'refresh-status'; return; }
  if (!lastRefresh) { el.textContent = 'Not loaded'; el.className = 'refresh-status error'; return; }
  const diff = Math.floor((Date.now() - lastRefresh) / 1000);
  let label;
  if (diff < 5) label = 'Live · just now';
  else if (diff < 60) label = 'Live · ' + diff + 's ago';
  else if (diff < 3600) label = 'Live · ' + Math.floor(diff/60) + 'm ago';
  else label = 'Live · ' + Math.floor(diff/3600) + 'h ago';
  el.textContent = label;
  el.className = 'refresh-status live';
}

function parseGvizResponse(text) {
  const m = text.match(/google\.visualization\.Query\.setResponse\(([\s\S]+)\);?/);
  if (!m) throw new Error('Unexpected response format from Google Sheets');
  return JSON.parse(m[1]);
}

function rowsToProducts(table) {
  const cols = table.cols.map(c => (c.label || '').trim());
  const idx = {};
  cols.forEach((label, i) => { idx[label.toLowerCase().replace(/\s+/g, ' ').trim()] = i; });
  function getCell(row, ...possibleNames) {
    for (const n of possibleNames) {
      const i = idx[n.toLowerCase().replace(/\s+/g, ' ').trim()];
      if (i !== undefined && row.c[i]) return row.c[i].v;
    }
    return null;
  }
  const out = [];
  for (const row of table.rows) {
    if (!row.c) continue;
    const brand = getCell(row, 'Brand');
    if (!brand) continue;
    const cost = Number(getCell(row, 'Average Cost', 'Cost') || 0);
    const sp   = Number(getCell(row, 'Sales Price', 'Sales\u00a0Price') || 0);
    const p1   = Number(getCell(row, 'Prices 1', 'Price 1') || 0);
    const p5   = Number(getCell(row, 'Prices 5-11', 'Prices 5–11', 'Price 5-11') || 0);
    const p12  = Number(getCell(row, 'Prices 12+', 'Price 12+') || 0);
    out.push({
      ref: String(getCell(row, 'Internal Reference', 'Reference') || '').trim(),
      brand: String(brand).trim().toUpperCase(),
      name: String(getCell(row, 'Name', 'Product') || '').trim(),
      cost: cost,
      sales_price: sp,
      p1: p1, p5: p5, p12: p12,
    });
  }
  return out;
}

async function loadData() {
  if (isLoading) return;
  isLoading = true;
  updateStatusBadge();
  const btn = document.getElementById('refreshBtn');
  if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

  try {
    const url = SHEET_URL + '&_t=' + Date.now();
    const resp = await fetch(url);
    if (!resp.ok) throw new Error('HTTP ' + resp.status + ' — sheet may not be public.');
    const text = await resp.text();
    const json = parseGvizResponse(text);
    if (json.status === 'error') {
      const msg = (json.errors && json.errors[0] && json.errors[0].detailed_message) || 'Sheet error';
      throw new Error(msg);
    }
    PRODUCTS = rowsToProducts(json.table);
    if (!PRODUCTS.length) throw new Error('No rows found in ' + SHEET_NAME + '.');

    lastRefresh = Date.now();
    renderKPIs();
    renderBrandList();
    renderContent();
    updateStatusBadge();
  } catch (err) {
    console.error(err);
    showErrorState(err.message || String(err));
    const el = document.getElementById('refreshStatus');
    if (el) { el.textContent = 'Error'; el.className = 'refresh-status error'; }
  } finally {
    isLoading = false;
    if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
  }
}

document.getElementById('refreshBtn').addEventListener('click', loadData);

setInterval(() => { if (!document.hidden) loadData(); }, AUTO_REFRESH_MS);
setInterval(updateStatusBadge, 30000);

document.addEventListener('visibilitychange', () => {
  if (!document.hidden && lastRefresh && (Date.now() - lastRefresh) > 60000) {
    loadData();
  }
});

// ---------- Init ----------
showLoadingState();
loadData();
